import { useMsal } from '@azure/msal-react';

export const useRoles = () => {
  const msal = useMsal();
  return msal.accounts.flatMap((a) => a.idTokenClaims?.roles || []);
};

const useHasRoleOfType = (type: 'User' | 'Reader' | 'TAR_Admin' | 'Maint_User' | 'Maint_Admin') => {
  const roles = useRoles();
  return roles.includes(type);
};

export const useHasUserAccess = () => useHasRoleOfType('User');
export const useHasTarAdminAccess = () => useHasRoleOfType('TAR_Admin');
export const useHasMaintenanceUserAccess = () => useHasRoleOfType('Maint_User');
export const useHasMaintenanceAdminAccess = () => useHasRoleOfType('Maint_Admin');

export const useCurrentUsername = () => {
  const { accounts } = useMsal();
  const account = accounts[0];
  return account ? `[${account.name ?? ''}](${account.username ?? ''})` : '';
};
